import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCheckoutService } from 'services';
import {
  getDsoCartErrorMessage,
  isDsoCartValidationError,
} from 'components/DSO/DsoCartErrorModal/DsoCartErrorModal.helper';

export const useDsoProceedToCheckout = (
  setDsoProceedToCheckout: Dispatch<SetStateAction<boolean>>,
  setCheckoutError?: Dispatch<SetStateAction<string[]>>
) => {
  const queryClient = useQueryClient();

  return useMutation(() => dsoCheckoutService.proceedToDsoCheckout(), {
    onSuccess: data => {
      queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
      setDsoProceedToCheckout(true);
      if (setCheckoutError) {
        setCheckoutError([]);
      }
    },

    onError: (error: any) => {
      const backendErrors = error?.response?.data?.errors;
      const finalErrors: string[] = Array.isArray(backendErrors)
        ? backendErrors.map((err: unknown) =>
            isDsoCartValidationError(err)
              ? getDsoCartErrorMessage(err)
              : typeof err === 'string'
              ? err
              : 'An unexpected error occurred. Please try again.'
          )
        : backendErrors
        ? [
            isDsoCartValidationError(backendErrors)
              ? getDsoCartErrorMessage(backendErrors)
              : typeof backendErrors === 'string'
              ? backendErrors
              : 'An unexpected error occurred. Please try again.',
          ]
        : ['Unable to proceed to checkout'];
      setCheckoutError?.(finalErrors);
      console.error(error);
    },
  });
};
